import React from "react";
import { useBookingWeekCardGetQuery } from "@graphql";
import { ErrorDialog, Spinner } from "@components";
import { BookingWeekCard } from "./BookingWeekCard";

type Props = {
  bookingId: string;
  onOpen?: () => any;
  onEdit?: () => any;
};

export function BookingWeekCardQuery(props: Props) {
  const { bookingId } = props;

  const { data, loading, error } = useBookingWeekCardGetQuery({
    variables: { bookingId },
    fetchPolicy: "no-cache" // otherwise it crashes with apollo cache error from time to time
  });

  if (loading) {
    return <Spinner />;
  }

  if (error) {
    return <ErrorDialog open message={error.toString()} />;
  }

  return (
    <BookingWeekCard
      item={data.bookingById}
      onOpen={props.onOpen}
      onEdit={props.onEdit}
    />
  );
}
